export enum BookForSomeoneElseCheckboxDataHooks {
  CHECKBOX = 'book-for-someone-else-checkbox',
  TOOLTIP = 'book-for-someone-else-tooltip',
}
